import React from 'react';
import { Box, Typography } from '@mui/material';

// *Keeps a Notary page error inside the page instead of crashing the whole dashboard
class NotaryErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.log('Notary page error', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 3 }}>
          <Typography variant="h6">Something went wrong while loading Notary Approvals.</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>Please refresh the page or contact support.</Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default NotaryErrorBoundary;
